import React from 'react';
import { X } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { DateFilterPicker } from './DateFilterPicker';
import { MunicipalitySelect } from './MunicipalitySelect';
import type { MunicipalListFilterValues } from '../types/pre-registration.types';

interface MunicipalListsFiltersProps {
  values: MunicipalListFilterValues;
  onChange: (values: MunicipalListFilterValues) => void;
}

export const MunicipalListsFilters: React.FC<MunicipalListsFiltersProps> = ({ values, onChange }) => {
  const hasFilters =
    values.municipalityId !== undefined ||
    values.surveyDateFrom !== undefined ||
    values.surveyDateTo !== undefined;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div className="space-y-1">
          <Label htmlFor="municipality">Municipio</Label>
          <MunicipalitySelect
            id="municipality"
            value={values.municipalityId}
            onChange={(municipalityId) => onChange({ ...values, municipalityId })}
          />
        </div>

        <div className="space-y-1">
          <Label htmlFor="survey-date-from">Relevamiento desde</Label>
          <DateFilterPicker
            id="survey-date-from"
            value={values.surveyDateFrom}
            maxDate={values.surveyDateTo}
            onChange={(surveyDateFrom) => onChange({ ...values, surveyDateFrom })}
          />
        </div>

        <div className="space-y-1">
          <Label htmlFor="survey-date-to">Relevamiento hasta</Label>
          <DateFilterPicker
            id="survey-date-to"
            value={values.surveyDateTo}
            minDate={values.surveyDateFrom}
            onChange={(surveyDateTo) => onChange({ ...values, surveyDateTo })}
          />
        </div>
      </div>

      <div className="flex items-center justify-between">
        <p className="text-xs text-gray-500">
          Al filtrar por fecha se excluyen los listados sin fecha de relevamiento.
        </p>
        {hasFilters && (
          <Button variant="ghost" size="sm" onClick={() => onChange({})}>
            <X className="mr-1 h-4 w-4" />
            Limpiar filtros
          </Button>
        )}
      </div>
    </div>
  );
};
